import {
  Tab,
  TabLabel,
  Tabs,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import { Box } from '@material-ui/core';
import React, { memo, useCallback, useMemo, useState } from 'react';
import { hot } from 'react-hot-loader/root';
import { useHistory } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { OrgProvider } from 'src/hooks/useOrg';
import { OrgAdminsProvider } from 'src/hooks/useOrgAdmins';
import { OrgUsersProvider } from 'src/hooks/useOrgUsers';
import OrgDetails from './OrgDetails';
import OrgUsers from './OrgUsers';
import { useStyles } from './styles';

export const enum MyOrganisationTabs {
  Admins = 'Admins',
  Users = 'Users',
}

const MyOrganisationPage: React.FC = () => {
  const { user } = useAuth();
  const history = useHistory();

  const getInitialTabIndex = useCallback(() => {
    const isReturned = history.action === 'POP';
    if (isReturned) {
      return JSON.parse(sessionStorage.getItem('tableSettings'))?.tab ===
        MyOrganisationTabs.Admins
        ? 0
        : 1;
    }
    return 0;
  }, [history.action]);

  const [tabIndex, setTabIndex] = useState(getInitialTabIndex);

  const orgName = user.organisationLegacyNumber
    ? `${user.organisationLegacyNumber} - ${user.organisationName}`
    : user.organisationName;

  const content = useMemo(
    () =>
      !tabIndex ? (
        <OrgProvider>
          <OrgAdminsProvider>
            <OrgDetails />
          </OrgAdminsProvider>
        </OrgProvider>
      ) : (
        <OrgProvider>
          <OrgUsersProvider>
            <OrgUsers />
          </OrgUsersProvider>
        </OrgProvider>
      ),
    [tabIndex]
  );

  const classes = useStyles();
  return (
    <Box>
      <Typography variant="h2" className={classes.title} data-testid="title">
        {orgName}
      </Typography>
      <Tabs
        onChange={
          ((_, value) => {
            setTabIndex(value);
          }) as any
        }
        value={tabIndex}
        className={classes.tabs}
        data-testid="tabs"
      >
        <Tab
          label={<TabLabel label={MyOrganisationTabs.Admins} />}
          data-testid="admins-tab"
        />
        <Tab
          label={<TabLabel label={MyOrganisationTabs.Users} />}
          data-testid="users-tab"
        />
      </Tabs>
      {content}
    </Box>
  );
};

export default hot(memo(MyOrganisationPage));
